import clsx from 'clsx';
import type * as React from 'react';

export type PageHeaderProps = React.ComponentPropsWithoutRef<'header'>;

/**
 * Page header landmark without border.
 */
export function PageHeaderChromeless(props: PageHeaderProps) {
    return <header {...props} className={clsx('flex min-h-16 items-center', props.className)} />;
}

/**
 * Page header landmark.
 */
export function PageHeader(props: PageHeaderProps) {
    return (
        <PageHeaderChromeless
            {...props}
            className={clsx('border-b bg-base px-4 md:px-10', props.className)}
        />
    );
}
